import type { FormControl } from '@angular/forms';
import type { SelectedFileExtended } from '@common/types/file.type';

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Validators } from '@angular/forms';

import { RELATIVE_AND_ABSOLUTE_URL } from '@common/regexp';
import { WebBaseControlSettingsComponent } from '@web/widgets/common/abstract/web-base-control-settings.component';
import { CommonElementsModule } from '@web/widgets/common/common-elements.module';

@Component({
    selector: 'web-logo-settings',
    templateUrl: './logo-settings.component.html',
    styleUrls: ['./logo-settings.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonElementsModule],
})
export class LogoSettingsComponent extends WebBaseControlSettingsComponent<SelectedFileExtended> {
    protected initForm(): void {
        this.form = this.fb.group({
            alt: null,
            link: [null, [Validators.pattern(RELATIVE_AND_ABSOLUTE_URL)]],
        });
    }

    protected setFormData(): void {
        const data: Partial<SelectedFileExtended> = {
            link: this.item.link,
            alt: this.item.alt,
        };

        this.form.setValue(data as any, { emitEvent: false });
    }

    public get alt(): FormControl<string> {
        return this.form.get('alt') as FormControl<string>;
    }

    public get link(): FormControl<string> {
        return this.form.get('link') as FormControl<string>;
    }
}
